"use client"
import { ImageUploadField } from "@/(admin)/modules/ui-builder/config/lib/ImageUploadField"
import { ComponentConfig } from "@measured/puck"
import { RenderConfig, VideoProps } from "./RenderConfig"

export const Video: ComponentConfig<VideoProps> = {
  label: "Video",
  fields: {
    linkVideo: {
      label: "Link Video",
      type: "text",
    },
    image: {
      label: "Image",
      type: "custom",
      render: props => <ImageUploadField {...props} />,
    },
    heightMobile: {
      label: "Height Mobile",
      type: "text",
    },
    heightDesktop: {
      label: "Height Desktop",
      type: "text",
    },
    widthMobile: {
      label: "Width Mobile",
      type: "text",
    },
    widthDesktop: {
      label: "Width Desktop",
      type: "text",
    },
    borderRadius: {
      label: "Border Radius",
      type: "text",
    },
  },
  defaultProps: {
    heightDesktop: "618px",
    widthDesktop: "1203px",
  },
  ...RenderConfig,
}
